import React from "react";

export default function UsersIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="74"
      viewBox="0 0 74 74"
      fill="none"
    >
      <g clip-path="url(#clip0_579_928)">
        <path
          d="M35.4583 37C41.4184 37 46.25 32.1684 46.25 26.2084C46.25 20.2483 41.4184 15.4167 35.4583 15.4167C29.4983 15.4167 24.6667 20.2483 24.6667 26.2084C24.6667 32.1684 29.4983 37 35.4583 37Z"
          fill="#42C3CF"
        />
        <path
          d="M57.0417 43.1667C61.2989 43.1667 64.75 39.7155 64.75 35.4583C64.75 31.2011 61.2989 27.75 57.0417 27.75C52.7845 27.75 49.3333 31.2011 49.3333 35.4583C49.3333 39.7155 52.7845 43.1667 57.0417 43.1667Z"
          fill="#42C3CF"
        />
        <path
          d="M14.0939 43.1667C18.3511 43.1667 21.8023 39.7155 21.8023 35.4583C21.8023 31.2011 18.3511 27.75 14.0939 27.75C9.83673 27.75 6.38559 31.2011 6.38559 35.4583C6.38559 39.7155 9.83673 43.1667 14.0939 43.1667Z"
          fill="#42C3CF"
        />
        <path
          d="M35.4583 40.0833C30.145 40.0898 25.0511 42.2035 21.2939 45.9606C17.5368 49.7177 15.4232 54.8116 15.4167 60.125C15.4167 60.5339 15.5791 60.926 15.8682 61.2151C16.1573 61.5042 16.5495 61.6666 16.9583 61.6666H53.9583C54.3672 61.6666 54.7593 61.5042 55.0485 61.2151C55.3376 60.926 55.5 60.5339 55.5 60.125C55.5 49.0743 46.509 40.0833 35.4583 40.0833ZM16.7517 46.583C15.8071 46.3716 14.8429 46.26 13.875 46.25C10.1964 46.2541 6.66958 47.7172 4.0684 50.3184C1.46722 52.9196 0.00408057 56.4464 0 60.125C0 60.5339 0.162425 60.926 0.451544 61.2151C0.740662 61.5042 1.13279 61.6666 1.54167 61.6666H12.617C12.4344 61.1729 12.3384 60.6514 12.3333 60.125C12.3333 55.0652 13.986 50.394 16.7517 46.583ZM57.0417 46.25C56.0673 46.25 55.1084 46.3826 54.1649 46.583C57.0349 50.515 58.5821 55.2569 58.5833 60.125C58.5833 60.6676 58.4723 61.1826 58.2997 61.6666H69.375C69.7839 61.6666 70.176 61.5042 70.4651 61.2151C70.7542 60.926 70.9167 60.5339 70.9167 60.125C70.9167 52.4752 64.6914 46.25 57.0417 46.25Z"
          fill="#42C3CF"
        />
      </g>
      <defs>
        <clipPath id="clip0_579_928">
          <rect width="74" height="74" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
